import React from 'react';

import { BoxWithButtonAndImage } from '@pages-impl/golang-development/common/BoxWithButtonAndImage';
import { StandardSection } from '@commons/standard-section/StandardSection';
import { Button } from '@commons/button/Button';

import imageOnLeft from '@images/mvp-development/lets-talk/imgOnLeft.png';
import imageOnRight from '@images/mvp-development/lets-talk/imgOnRight.png';

import * as styles from './lets-talk-section.module.scss';

export const LetsTalkSection = ({
  firstHeading,
  secondHeading,
  buttonLink,
  downloadImage,
  isMinVersion,
  id,
  buttonTitle = <>Let&apos;s talk</>,
  classNames: { section, innerWrapper, imageContainer, descriptionContainer, title, firstRow, buttonWithLink } = {},
}) => {
  const Content = () => {
    return isMinVersion ? (
      <div className={styles.innerContainer}>
        <Button label="Plan your MVP with us" href="#contact" className={styles.button} />
        <img loading="lazy" src={imageOnLeft} className={styles.imageOnLeft} alt="lets talk" />
        <img loading="lazy" src={imageOnRight} className={styles.imageOnRight} alt="lets talk" />
      </div>
    ) : (
      <BoxWithButtonAndImage
        downloadImage={downloadImage}
        buttonTitle={buttonTitle}
        buttonHref={buttonLink}
        classNames={{
          firstRow: firstRow || styles.firstRow,
          descriptionContainer: descriptionContainer || styles.descriptionContainer,
          imageContainer: imageContainer || styles.imageContainer,
          buttonWithLink: buttonWithLink || styles.buttonWithLink,
        }}
      >
        <h2 className={title || styles.title}>{firstHeading}</h2>
        <h2 className={styles.regularFont}>{secondHeading}</h2>
      </BoxWithButtonAndImage>
    );
  };

  return (
    <StandardSection
      className={section}
      classNames={{
        innerWrapper: innerWrapper || styles.innerWrapper,
        outerWrapper: isMinVersion && styles.outerWrapper,
      }}
      id={id}
    >
      <Content />
    </StandardSection>
  );
};
